export default "__VITE_ASSET__BWyMhJFq__"